// Central route-path registry. Modules reference these constants instead of
// hard-coding path strings, so a path change is a single edit here.
//
// Seed set only — add each feature's paths here as you build its module, then
// register that module's route records in `privateRoutes.ts` / `publicRoutes.ts`.
export const routes = {
  HOME: '/',
  LOGIN: '/login',
  VERIFY_OTP: '/login/verify',
  DASHBOARD: '/dashboard',
  LISTINGS: '/listings',
  LISTING_NEW: '/listings/new',
  LISTING_AGREEMENT_SIGN_RETURN: '/listings/agreements/sign-return',
  LISTING_DETAIL: '/listings/:id',
  // The signed-in seller completing their own owner onboarding for one request —
  // the logged-in twin of PUBLIC_OWNER_ONBOARDING, without the emailed token.
  LISTING_OWNER_ONBOARDING: '/listings/:id/owner-onboarding',
  // Properties the seller's approved requests were promoted into (read-only —
  // there is no create path, promotion is admin-driven).
  PROPERTIES: '/properties',
  PROPERTY_DETAIL: '/properties/:id',
  // The seller's properties that are live or whose funding closed. Not the
  // investor/admin Marketplace (secondary market) — same name, different purpose.
  MARKETPLACE: '/marketplace',
  MARKETPLACE_DETAIL: '/marketplace/:id',
  // The signed-in seller's own account details (read-only).
  PROFILE: '/profile',
  // Help & Support hub — entry point to FAQs, Contact Us and the support channels.
  SUPPORT: '/support',
  SUPPORT_FAQS: '/support/faqs',
  SUPPORT_CONTACT: '/support/contact',
  // Public (no-login) contact form, linked from the sign-in footer.
  SUPPORT_PUBLIC_CONTACT: '/contact',
  // Public (no-login) owner signing via a secure emailed/shared link.
  PUBLIC_AGREEMENT_SIGN: '/agreements/sign/:token',
  PUBLIC_AGREEMENT_SIGN_RETURN: '/agreements/sign/:token/return',
  // Public (no-login) property-owner onboarding. admin-service mails this exact
  // path — changing it breaks links already sitting in owners' inboxes.
  PUBLIC_OWNER_ONBOARDING: '/owners/onboarding/:token',
  // Seller guides — static editorial content behind the dashboard's
  // "Before you list" / "After you list" cards. `:slug` is an article slug from
  // the learn module's content, not an id.
  LEARN: '/learn',
  LEARN_ARTICLE: '/learn/:slug',
  // Policies & Legal — public, so the sign-in footer and the sign-up form can
  // link to them. `:slug` is a document slug from the legal module's catalogue.
  LEGAL: '/legal',
  LEGAL_DOCUMENT: '/legal/:slug',
  ERROR: '/error',
  NOTFOUND: '/not-found',
} as const
